export default "__VITE_ASSET__2TatrT9z__"